import { render, staticRenderFns } from "./client-chart-container.vue?vue&type=template&id=d510162a&"
import script from "./client-chart-container.vue?vue&type=script&lang=js&"
export * from "./client-chart-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports